import { concat, remove } from 'lodash'

import * as actionType from '../constants/constant.action'

const defaultSelectedProvider = {
  providerNameTitle: '',
}

const defaultState = {
  counter: 0,
  providerSelected: [defaultSelectedProvider],
  selectedCarepoints: [],
}

const providerSelectedReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.SELECT_PROVIDER_CARE_POINT_UUID:
      return {
        ...state,
        selectedCarepoints: concat(state.selectedCarepoints, action.payload),
      }

    case actionType.REMOVE_PROVIDER_CARE_POINT_UUID:
      if (state.counter === 0) {
        return {
          ...state,
          selectedCarepoints: [],
        }
      }
      remove(state.selectedCarepoints, function (n) {
        return n === action.payload
      })

      break

    case actionType.SHUFFLE_SELECT_PROVIDER_CARE_POINT_UUID:
      const data = action.payload.filter(item => item.providerNameTitle !== '')
      return {
        ...state,
        selectedCarepoints: data,
      }

    case actionType.SELECT_PROVIDER_DETAIL:
      const updatedProviderArray = state.providerSelected.map((v, i) => {
        if (i === state.counter) {
          return (v = action.payload)
        }
        return v
      })

      return {
        ...state,
        providerSelected: updatedProviderArray,
      }

    case actionType.REMOVE_SELECTED_PROVIDER_DETAIL:
      const carepoint = action.payload
      const indexOfCarepoint = state.selectedCarepoints.findIndex(
        item => item.npi === carepoint.npi && item.key === carepoint.key
      )
      const carepointCollection = [...state.selectedCarepoints]
      const memberSelection = [...state.providerSelected]

      memberSelection[indexOfCarepoint] = null
      carepointCollection[indexOfCarepoint] = null

      const memberSelectionSorted = memberSelection
        .sort()
        .map(v => (v === null ? defaultSelectedProvider : v))
      const memberCarePointCollectionSorted = carepointCollection.filter(
        v => v !== null
      )

      return {
        ...state,
        providerSelected: memberSelectionSorted,
        selectedCarepoints: memberCarePointCollectionSorted,
        counter: state.counter - 1,
      }

    case actionType.INCREAMENT_COUNT:
      return {
        ...state,
        counter: state.counter + 1,
      }

    case actionType.DECREAMENT_COUNT:
      return {
        ...state,
        counter: state.counter - 1,
      }

    case actionType.SHUFFLE_SELECTED_PROVIDER_DETAIL:
      return {
        ...state,
        providerSelected: [...action.payload],
      }

    case actionType.CLEAN_PROVIDER_DETAIL:
      return {
        ...defaultState,
      }

    default:
      return {
        ...state,
      }
  }
}

export default providerSelectedReducer
